/**
 * Poussées vers le dataLayer de Google Tag Manager.
 *
 * Reprend les deux formes de l'ancien middleware redux d'analytics : l'événement simple
 * (`analyticsSetEvent`) et l'événement « Google » à libellé, dédoublonnable.
 */
const dataLayer = (): Record<string, unknown>[] => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
};

export const pushEvent = (event: string, datas: Record<string, unknown> | null = null): void => {
    dataLayer().push(datas ? { event, ...datas } : { event });
};

export interface GoogleEvent {
    event: string;
    actionGoogle?: string;
    libelle?: string;
    categorie?: string;
    valeur?: unknown;
    /** N'envoie l'événement qu'une fois par libellé sur la page. */
    unique?: boolean;
}

export const pushGoogleEvent = ({ event, actionGoogle, libelle, categorie, valeur, unique = false }: GoogleEvent): void => {
    const layer = dataLayer();

    const found = unique && layer.some((el) => el['libelle'] === libelle);

    if (!found) {
        layer.push({ event, action: actionGoogle, libelle, categorie, valeur });
    }

    if (!layer.some((el) => el['environnement'])) {
        layer.push({ environnement: 'production' });
    }
};
